/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2020 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
export const B64_CHARBLOCK=4;export const B64_PAD3=3;export const B64_PAD2=2;export const B64_PAD1=1;export const B64_PAD0=0;export const b64EffectiveData=(t,e=!1)=>{let n=t.indexOf("\n")===t.indexOf("\r")?t:t.replace(/[\n\r]/gu,"");if(n.length%4!=0){if(e)throw new Error("Invalid input length");switch(n.length%4){case 1:n=n.substring(0,4*Math.floor(n.length/4));break;case 2:n=`${n}==`;break;case 3:n=`${n}=`}}return n};